// O backend só aceita link http/https (o app abre no navegador; sem restringir
// o esquema passavam "javascript:" e afins). Validar aqui poupa a ida ao
// servidor e mostra o erro no campo certo.
export function linkValido(texto) {
  const valor = String(texto ?? '').trim();
  if (!valor) return false;
  try {
    const url = new URL(valor);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (e) {
    return false;
  }
}

export const MENSAGEM_LINK = 'Digite um link válido, começando com http:// ou https://';

// Link digitado por uma pessoa (não por um administrador): aceita "meusite.com.br"
// sem o esquema e acrescenta https://, mas NUNCA transforma um esquema perigoso em
// link válido. Quem digita "javascript:alert(1)" ou "ftp://x" recebe o texto como
// está e `linkValido` o recusa; só endereço SEM esquema ganha o https://.
//
// "host:porta" (meusite.com:8080) não é esquema: o que vem antes do ":" tem ponto,
// e esquemas não têm. Já "javascript:", "data:", "file:", "mailto:" e "tel:" são
// recusados pelo nome.
const ESQUEMA_COM_BARRAS = /^[a-z][a-z0-9+.-]*:\/\//i;
const ESQUEMA_SEM_BARRAS = /^(javascript|data|vbscript|file|mailto|tel|blob|about):/i;

export function normalizarLink(texto) {
  const valor = String(texto ?? '').trim();
  if (!valor) return '';
  if (/^https?:\/\//i.test(valor)) return valor;
  if (ESQUEMA_COM_BARRAS.test(valor) || ESQUEMA_SEM_BARRAS.test(valor)) return valor;
  return `https://${valor}`;
}
